<template>
  <!-- 设备管理-->
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline"
                style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备名称">
                <a-input v-model="query.deviceName"
                         placeholder="请输入设备名称"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备编号">
                <a-input v-model="query.deviceNo"
                         placeholder="请输入设备编号"
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12">
              <a-form-item label="设备类型">
                <a-select placeholder="请输入设备类型"
                          @change="handleChange"
                          v-model="query.deviceType">
                  <a-select-option v-for="(item, index) in typelist"
                                   :key="index"
                                   :value="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6"
                   :sm="12"
                   style="display: flex">
              <a-form-item>
                <a-button type="primary"
                          @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="primary"
                        style="margin-left: 12px"
                        @click="Handle('add')"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 12px"
                        @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id"
               :columns="columns"
               :data-source="list"
               :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
               :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
               :pagination="{ pageSize: 10 }"
               bordered>
        <span slot="action"
              slot-scope="text, record">
          <a @click="Handle('edit', record.id)">编辑</a>
        </span>
        <span slot="deviceaction"
              slot-scope="text">
          <span v-if="text == 0">正常</span>
          <span v-else>异常</span>
        </span>
      </a-table>
      <a-modal title="添加设备"
               okText="添加"
               width="50%"
               :visible="visible"
               :confirm-loading="confirmLoading"
               @ok="handleOk"
               @cancel="handleCancel">
        <a-form :form="addOrUpdateForm"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }">
          <a-form-item label="设备名称">
            <a-input v-decorator="['deviceName', { rules: [{ required: true, message: '请输入设备名称!' }] }]" />
          </a-form-item>
          <a-form-item label="设备类型">
            <a-select v-decorator="['deviceType', { rules: [{ required: true, message: '请选择设备类型!' }] }]"
                      placeholder="选择设备类型"
                      @change="handleChange">
              <a-select-option v-for="(item, index) in typelist"
                               :key="index"
                               :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="设备编号">
            <a-input v-decorator="['deviceNo', { rules: [{ required: true, message: '请输入设备编号!' }] }]" />
          </a-form-item>
          <a-form-item label="水厂名称">
            <a-input v-decorator="['waterWorksName', { rules: [{ required: true, message: '请输入水厂名称!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/common'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      deleteUrl: '/pipe-network/water_works_devices/',
      queryUrl: '/pipe-network/water_works_devices/page',
      queryOneUrl: '/pipe-network/water_works_devices/',
      actiontype: '',
      visible: false,
      confirmLoading: false,
      id: '',
      currentId: '',
      isUpdate: false,
      query: {
        deviceNo: '',
        deviceName: '',
        tenantId: this.$store.state.user.info.tenantId,
        deviceType: '',
        sysType: 4,
      },
      checklist: [],
      type: '选择设备类型',
      typelist: ['加压设备', '加药设备', '其他设备'],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        deviceNo: '',
        deviceType: '',
        waterWorksId: '',
        waterWorksName: '',
      },
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          align: 'center',
        },
        {
          title: '设备编号',
          dataIndex: 'deviceNo',
          align: 'center',
        },
        {
          title: '水厂名称',
          dataIndex: 'waterWorksName',
          align: 'center',
        },
        {
          title: '设备类型',
          dataIndex: 'deviceType',
          align: 'center',
        },
        {
          title: '设备状态',
          dataIndex: 'deviceStatus',
          align: 'center',
          scopedSlots: { customRender: 'deviceaction' },
        },
        // {
        //   title: '设备参数',
        //   dataIndex: 'deviceParameter',
        //   align: 'center',
        // },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      list: [],
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    },
  },
  created () {
    this.resetList()
  },
  methods: {
    resetList () {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRowKeys = []
      this.queryList()
    },
    handleChange (e) {
      this.type = e
      console.log(this.type)
    },
    onChange (id) {
      this.checklist.push(id)
      console.log(this.checklist)
    },
    Handle (type, id = '') {
      this.actiontype = type
      if (type == 'edit') {
        this.addOrUpdateHandle(id)
      } else {
        this.addOrUpdateHandle()
      }
      this.showModal()
    },
    showModal () {
      this.visible = true
    },
    handleOk () {
      // this.confirmLoading = true;
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          var url = '/pipe-network/water_works_devices'
          var method
          var params
          if (this.actiontype == 'add') {
            method = 'post'
            params = {
              deviceName: values.deviceName,
              deviceNo: values.deviceNo,
              deviceType: values.deviceType,
              waterWorksName: values.waterWorksName,
              sysType: 4,
            }
          } else {
            method = 'put'
            params = {
              id: this.currentId,
              deviceName: values.deviceName,
              deviceNo: values.deviceNo,
              deviceType: values.deviceType,
              waterWorksName: values.waterWorksName,
              sysType: 4,
            }
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token,
          }
          this.$http({
            url: url,
            method: method,
            data: params,
            header: header,
          }).then((data) => {

            this.visible = false
            // this.confirmLoading = false;
            if (this.actiontype == 'add') {
              this.$message.success('添加成功')
            } else {
              this.$message.success('修改成功')
            }
            // this.data = [];
            this.queryList()
          })
        }
      })
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
